



































/* Created- 16 - May - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { AccountArticleLicenceDTO } from "../../Generated/ParticaAPI";
import { ButtonConfig, ButtonStatus } from "../../Models/Buttons";
import { eParticaAction, ParticaEvent } from "../../Models/ParticaEvent";
import { ArrayUtils } from "../../BusinessServices/arrayutils";
import { DateUtils } from "../../BusinessServices/dateutils";

@Component(
	{
		name: "ArticleLicenceTable",
		components: { ButtonList }
	})
export default class ArticleLicenceTable extends Vue {
	@Prop() private data: AccountArticleLicenceDTO[];
	@Prop() private selectedbuttons: ButtonConfig[];
	private selected: AccountArticleLicenceDTO[] = [];
	private search: string = "";
	private headers: any = [
		{ text: "Title", value: "title" },
		{ text: "Publication", value: "publication" },
		{ text: "Date", value: "timestamp" },
		{ text: "Licence Name", value: "licenceName" },
	];

	@Watch("selected")
	private buttoncheck() {
		if (this.selected.length > 0) {
			this.selectedbuttons.forEach(button => {
				button.status = ButtonStatus.Enabled;
			});
		} else {
			this.selectedbuttons.forEach(button => {
				button.status = ButtonStatus.Disabled;
			});
		}
	}

	private select(item: AccountArticleLicenceDTO) {
		this.$emit("partica-event", { action: eParticaAction.LEFT_MOUSE_CLICK, item } as ParticaEvent);
	}
	private right(item: AccountArticleLicenceDTO) {
		this.$emit("partica-event", { action: eParticaAction.RIGHT_MOUSE_CLICK, item } as ParticaEvent);
	}
	private selectArticle(item: AccountArticleLicenceDTO, value: any) {
		item.selected = value;
		if (item.selected) {
			this.selected.push(item);
		} else {
			this.selected = ArrayUtils.remove(this.selected, item);
		}
	}
	private checkselect(checked: any) {
		this.data.forEach(article => {
			article.selected = false;
		});
		this.selected = checked;
		this.selected.forEach(row => {
			row.selected = true;
		});
	}

	private selectAction(event: ParticaEvent) {
		event.item = this.selected;
		this.$emit("partica-event", event);
	}

	private getDate(date: Date) {
		return DateUtils.FormatDate(date, "YYYY-MMM-DD");
	}
}
